import { QrPaymentView } from '../../../checkout/QrPaymentView.js';
import type { UsePhoneFirstDonationJourneyResult } from '../../hooks/usePhoneFirstDonationJourney.js';

export type PhoneFirstDonationPayStepViewProps = Pick<
  UsePhoneFirstDonationJourneyResult,
  | 'paymentId'
  | 'checkoutSessionId'
  | 'qrPayload'
  | 'qrVisible'
  | 'amountMinor'
  | 'displayCurrency'
  | 'restart'
  | 'navigate'
>;

export function PhoneFirstDonationPayStepView(props: PhoneFirstDonationPayStepViewProps): JSX.Element {
  const {
    paymentId,
    checkoutSessionId,
    qrPayload,
    qrVisible,
    amountMinor,
    displayCurrency,
    restart,
    navigate,
  } = props;

  if (paymentId === null) {
    return <></>;
  }

  return (
    <QrPaymentView
      paymentId={paymentId}
      checkoutSessionId={checkoutSessionId}
      qrCodePayload={qrPayload}
      qrVisible={qrVisible}
      amountMinor={amountMinor}
      currency={displayCurrency ?? undefined}
      analyticsFlow="DONATION"
      onCancel={restart}
      onContinue={() => navigate('..')}
    />
  );
}
